import React from "react";
import { Helmet } from "react-helmet-async";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Scroll from "../Header/Scroll";
import Container from "../../common/Container";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Banner from "./components/Banner";
import Intro from "./components/Intro";
import Image from "../../assets/images/lagoon.jpg";
import Industry from "./components/Industry";
import Goals from "./components/Goals";
import Justification from "./components/Justification";
import Image2 from "../../assets/images/ocean.jpg";
import ContactHeader from "../Header/ContactHeader";
import Details from "../Advisory/components/Details";
import Management from "./components/Management";

const styles = {
  paperContainer: {
    height: 300,
    backgroundImage: `linear-gradient(rgba(0,0,95,0.5),rgba(0,0,95,0.5)), url(${Image})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

const styles2 = {
  paperContainer: {
    height: 1700,
    backgroundImage: `url(${Image2})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    objectFit: "cover",
  },
};

const About = () => {
  const theme = useTheme();
  return (
    <Box>
      <Helmet>
        <title> About Us | Aquatic Hub Afrique</title>
      </Helmet>
      <Box
        bgcolor={"#194ec3"}
        position={"relative"}
        display={{ xs: "none", sm: "block" }}
      >
        <ContactHeader />
      </Box>
      <Scroll>
        <AppBar
          position={"sticky"}
          elevation={0}
          sx={{
            backgroundColor: theme.palette.background.paper,
            padding: "10px 0px",
          }}
        >
          <Container paddingY={{ xs: 1 / 2, sm: 1 / 2 }}>
            <Header />
          </Container>
        </AppBar>
      </Scroll>
      <Box style={styles.paperContainer}>
        <Container>
          <Banner />
        </Container>
      </Box>
      <Box>
        <Container>
          <Intro />
          <Industry />
        </Container>
      </Box>
      <Box display={{ xs: "none", sm: "inline" }}>
        <Goals />
      </Box>
      <Box style={styles2.paperContainer} display={{ xs: "block", sm: "none" }}>
        <Goals />
      </Box>
      <Box>
        <Container>
          <Justification />
        </Container>
      </Box>
      <Box>
        <Container>
          <Management />
          <Details />
        </Container>
      </Box>
      <Box bgcolor={"#000058"}>
        <Container>
          <Footer />
        </Container>
      </Box>
    </Box>
  );
};

export default About;
